const addProj = () => import(/* webpackChunkName: "herb" */ './addProj');
const indexApp = () => import('./indexAppl.vue');
const indexAdmin = () => import('./indexAdmin');
const indusEdit = () => import('./indusEdit');
const indusClusterEdit = () => import('./indusClusterEdit.vue');
const smesClusterEdit = () => import('./smesClusterEdit.vue')
const smsHqEdit = () => import('./smsHqEdit');
const smsLoanEdit = () => import('./smsLoanEdit.vue');
const pubServBaseEdit = () => import('./pubServBaseEdit.vue');
const pubServPlatformEdit = () => import('./pubServPlatformEdit.vue');
const smsDigitalEdit = () => import('./smsDigitalEdit.vue');

//2023项目储备库管理
export default {
  routes: [
    {
      path: '/projlib/v2024/indexApp',
      name: 'proj_lib_v2024_index_App',
      component: indexApp,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/indexAdmin',
      name: 'proj_lib_v2024_index_Admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/addProj',
      name: 'proj_lib_v2024_add_proj',
      component: addProj,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/indusEdit',
      name: 'proj_lib_v2024_indus_edit',
      component: indusEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/indusClusterEdit',
      name: 'proj_lib_v2024_indus_cluster_edit',
      component: indusClusterEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/smesClusterEdit',
      name: 'proj_lib_v2024_smes_cluster_edit',
      component: smesClusterEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/smsHqEdit',
      name: 'proj_lib_v2024_sm_hq_edit',
      component: smsHqEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/smsLoanEdit',
      name: 'proj_lib_v2024_sm_loan_edit',
      component: smsLoanEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/pubServPlatformEdit',
      name: 'proj_lib_v2024_pub_serv_platform_edit',
      component: pubServPlatformEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/pubServBaseEdit',
      name: 'proj_lib_v2024_pub_serv_base_edit',
      component: pubServBaseEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2024/smsDigitalEdit',
      name: 'proj_lib_v2024_sms_digital_edit',
      component: smsDigitalEdit,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/projLib/V2024/router.js